import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, IconButton } from '@mui/material';
import React from 'react';

interface Props {
  open: boolean;
  handleClose?: () => void;
  children: React.ReactNode;
}

const DefaultModal = (props: Props): JSX.Element => {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <Box sx={{ display: 'flex', justifyContent: 'end', p: 1 }}>
        {props.handleClose && (
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      {props.children}
    </Dialog>
  );
};

export default DefaultModal;
